module.exports = __webpack_public_path__ + "b8b4603485645e8f64ea26474941ef4c.jpg";